// Eager slim slice of the preview component barrel (#16 preview half).
//
// The full `./index.js` barrel `export *`s the entire preview UI tree — Scene,
// SceneTemplate, SceneNavbar, PreviewNavbar, PreviewSidebar, PreviewAssistant,
// PreviewErrorBoundary (~121KB with the page module) — that the unified shell
// dragged into its EAGER chunk via
// `import * from '../preview/components/index.js'` in workspace/context.js.
//
// Preview is now a lazy sub-app: the `/preview` ROUTE (workspace/pages/index.js
// → lazySharedLib) and the `/preview` PageSlot (workspace/pages/main.js
// _previewPage → lazySharedLibPage) both FOLD the full preview context
// (components + functions) into the live shell context on first mount, THEN
// el.set the preview page — so every one of the components above, bare-keyed
// ONLY from inside that page tree, resolves against the now-populated registry.
// None of it is reached before the fold.
//
// This slice is intentionally EMPTY: an exhaustive grep of the whole eager
// surface (workspace app.js/state/pages/components/functions + shared/** +
// the canvas/marketplace eager slices) found NO non-preview eager surface that
// bare-keys or `extends` any preview component before a /preview fold —
//   • app.js has ZERO preview references (unlike marketplace, whose shell-root
//     install-modal watcher forced MarketplaceInstallModal to stay eager);
//   • the only `Scene` / `SceneNavbar` hits outside preview are CANVAS's own
//     components, which export a DIFFERENTLY-KEYED `CanvasScene` (+ a canvas
//     `SceneNavbar` child) — no key collision with preview's `Scene`;
//   • every other hit (PreviewNavbar, PreviewSidebar, …) is a code comment or a
//     local variable, never a component bare-key/extend.
//
// So preview contributes NOTHING to the shell's eager component chunk. This file
// exists as the documented seam (imported by workspace/context.js in place of the
// full barrel) — if a future eager surface ever references a preview component,
// add its `export * from './<Component>.js'` here (source file, not the barrel:
// preview has no `sideEffects: false`, so a barrel re-export would evaluate the
// whole UI tree and defeat the carve).
//
// The AI-answer views (functions/previewAnswer.js) are such keys: the
// assistant's thread and a Fly page mount them on ANY route, never folding the
// preview app — the site live (`site-preview`), its pages as tiles
// (`project-pages`), its design system (`design-system`). Zero imports; the
// one step that needs the preview app (inspect) folds it on demand.
export * from './SitePreviewView.js'
export * from './ProjectPagesView.js'
export * from './PreviewDesignSystemView.js'
